import React, { memo } from 'react';
import cn from 'classnames';

import Checkbox from '@components/common/Checkbox';
import Tooltip from '@components/common/Tooltip';

import { ICheckboxOptionsTypes } from './CheckboxOptions.types';

import './CheckboxOptions.scss';

const CheckboxOptions = ({
	chart,
	isColumn = false,
	isDisabledCompare,
	isDisabledCorrelate,
	toggleAddToCompare,
	isCheckedCompare,
	listOfTooltipCompareMessage,
	isCheckedCorrelate,
	listOfTooltipCorrelateMessage,
	toggleAddToCorrelate,
}: ICheckboxOptionsTypes) => (
	<div className={cn('f5gCheckboxOptionsContainer', { 'f5gCheckboxOptionsContainerColumn': isColumn })}>
		<Tooltip
			content={<div className='f5gCheckboxOptionsTooltip'>
				The chart can’t be added to compare due to:
				<ul>
					{listOfTooltipCompareMessage.map(error => (
						<li key={error + chart.chartId}>{error}</li>
					))}
				</ul>
			</div>}
			isDisabled={!isDisabledCompare || isCheckedCompare}
		>
			<div>
				<Checkbox
					checked={isCheckedCompare}
					disabled={isDisabledCompare && !isCheckedCompare}
					label='Add to compare'
					name={`select-kpi-compare-${chart.chartId}`}
					onChange={toggleAddToCompare}
				/>
			</div>
		</Tooltip>
		<Tooltip
			content={<div className='f5gCheckboxOptionsTooltip'>
				The chart can’t be added to correlate due to:
				<ul>
					{listOfTooltipCorrelateMessage.map(error => (
						<li key={error + chart.chartId}>{error}</li>
					))}
				</ul>
			</div>}
			isDisabled={!isDisabledCorrelate || isCheckedCorrelate}
		>
			<div>
				<Checkbox
					checked={isCheckedCorrelate}
					disabled={isDisabledCorrelate && !isCheckedCorrelate}
					label='Add to correlate'
					name={`select-kpi-correlate-${chart.chartId}`}
					onChange={toggleAddToCorrelate}
				/>
			</div>
		</Tooltip>
	</div>
);

export default memo(CheckboxOptions);
